<template>
  <v-btn
    rounded
    depressed
    height="30"
    color="info"
    @click="selecionarProdutos()"
    :block="isMobile()"
    :large="isMobile()"
  >
    <v-icon left>mdi-cart-plus</v-icon> Adicionar produto</v-btn
  >
</template>

<script>
import { mapMutations, mapState } from "vuex";
export default {
  computed: { ...mapState("insumos", ["pedido_item"]) },
  methods: {
    ...mapMutations("insumos", ["setDialogProdInsumos"]),
    isMobile() {
      return this.$mq == "sm";
    },
    selecionarProdutos() {
      if (this.pedido_item.filialSelecionada == null) {
        this.$toasted.error("Por favor, selecione uma filial");
        return;
      } else if (this.pedido_item.cadproSelecionado == null) {
        this.$toasted.error("Por favor, selecione um cad-pro");
        return;
      } else if (this.pedido_item.culturaSelecionada == null) {
        this.$toasted.error("Por favor, selecione uma cultura");
        return;
      } else if (this.pedido_item.safraSelecionada == null) {
        this.$toasted.error("Por favor, selecione uma safra");
        return;
      } else if (
        this.pedido_item.vencimento == null ||
        this.pedido_item.vencimento == ""
      ) {
        this.$toasted.error("Por favor, informe o vencimento do pedido");
        return;
      }

      sessionStorage.setItem("pedido_item", JSON.stringify(this.pedido_item))

      /*if (this.isMobile() == 1) {                
        this.$router.push({ path: "/novo-pedido-insumos/selecionar-produtos" });
      } else {        */
        this.setDialogProdInsumos(true);
      ///}
    },
  },
};
</script>

<style>
</style>